import React from "react";
import userBadgeStyle from "assets/jss/hitract-styles/components/userBadgeStyle.js";
import { useNavigate } from "react-router-dom";
import makeStyles from '@mui/styles/makeStyles';
import PropTypes from "prop-types";
import Skeleton from 'react-loading-skeleton';

const useStyles = makeStyles(userBadgeStyle);

export default function UserBadge(props) {
    const classes = useStyles();
    const navigate = useNavigate();

    const [imageLoaded, setImageLoaded] = React.useState(false)

    const navigateToObject = () => {
        if(!props.userId === false) {
            navigate(`/student/${props.userId}`)
        }
        if(!props.companyId === false) {
            navigate(`/foretag/${props.companyId}`) 
        }
    }

    return (
        <div key={props.userId ? props.userId.toString() : props.companyId.toString()} className={`${props.userId && classes.cursor} classes.user`}>
            <div onClick={() => navigateToObject()} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', alignContent: 'center', alignSelf: 'center' }}>
            
                <Skeleton height={props.size === 'xs' ? 15 : props.size === 'sm' ? 20 : props.size === 'md' ? 39 : 60} width={props.size === 'xs' ? 15 : props.size === 'sm' ? 20 : props.size === 'md' ? 39 : 60} circle={true} style={imageLoaded ? {display: "none"} : {}}/>
                <img
                    src={props.avatar}
                    alt=''
                    title={props.name}
                    onLoad={() => setImageLoaded(true)}
                    style={ imageLoaded ? {} : {display: "none"}}
                    className={`${props.border && classes.border} ${props.noMargins && classes.noMargins} ${props.shadow ? classes.imgRaised : classes.noShadow} ${props.size === 'xs' ? classes.avatarXs : props.size === 'sm' ? classes.avatarSm : props.size === 'md' ? classes.avatarMd : classes.avatarLg}`}
                />
                <div>
                    {props.showName && <span className={classes.nameText}>{props.name}</span>}
                    {props.title && <span className={classes.titleText}>{props.title}</span>}
                </div>

            </div>
        </div>
    );
};

UserBadge.defaultProps = {
    size: 'xs',
    shadow: true,
    noMargins: false,
    border: false,
    userId: 0,
    companyId: 0,
    showName: true
}

UserBadge.propTypes = {
    size: PropTypes.string,
    shadow: PropTypes.bool,
    noMargins: PropTypes.bool,
    border: PropTypes.bool,
    showName: PropTypes.bool,
    userId: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]), 
    companyId: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]), 
    avatar: PropTypes.string,
    name: PropTypes.string,
    title: PropTypes.string
  }